module.exports = __webpack_public_path__ + "img/ammiraglio 1.18e70981.jpeg";